import React from 'react';
import moment from 'moment';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Table from '../../../../shared/table';
import { capitalizeWords } from '../../../../utils/capitalizeText';
import { INVOICES_STATUS } from '../../../../utils/constants/invoices-status';

const tableColumns = ['Agent', 'Timestamp', 'Customer', 'Invoice Status', 'Status', 'Description', 'Actions']

interface IActivitiesTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onSeeDetails: (data: any) => void;
}

const ActivitiesTable = ({
    rows,
    paginationData,
    rowsLoading,
    setPaginationState,
    onSeeDetails
}: IActivitiesTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.agent === 'accounting_agent' ? 'Accounting Agent' : row?.agent}</td>
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <p>Initiated: {moment(row?.startedAt)?.format('DD/MM/YYYY, h:mm:ss a')}</p>
                                    {row?.completedAt && <p>Completed:  {moment(row?.completedAt)?.format('DD/MM/YYYY, h:mm:ss a')}</p>}
                                </td>
                                <td className='px-6 py-4'>{row?.additionalInfo?.clientInfo?.name}</td>
                                <td className='px-6 py-4'>{row?.additionalInfo?.status ? INVOICES_STATUS?.find((item: any) => item?.value === row?.additionalInfo?.status)?.label || row?.additionalInfo?.status : ''}</td>
                                <td className='px-6 py-4'>{capitalizeWords(row?.status || '')}</td>
                                <td className='px-6 py-4'>{row?.task}</td>
                                <td className='px-6 py-4'>
                                    <div data-qa='details' onClick={() => (row?._id) && onSeeDetails(row)}>
                                        <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-2'} />
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default ActivitiesTable;